import { render, staticRenderFns } from "./FeedbackScale.vue?vue&type=template&id=0a8c4bc8&scoped=true&"
import script from "./FeedbackScale.vue?vue&type=script&lang=js&"
export * from "./FeedbackScale.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackScale.vue?vue&type=style&index=0&id=0a8c4bc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8c4bc8",
  null
  
)

export default component.exports